



































































































import { defineComponent, PropType } from '@vue/composition-api'

// components
import { Input, Select } from '@/components/general'

// types
import { AfpItemForm } from '@/models/config'

// constants
import { monthOptions, rangeYearsDefault } from '@/constants/dateTime'

export default defineComponent({
  name: 'TableAfpItems',
  components: {
    Input,
    Select
  },
  props: {
    items: {
      type: Array as PropType<AfpItemForm[]>,
      required: true
    },
    validations: {
      type: Object
    }
  },
  setup () {
    return {
      monthOptions,
      rangeYearsDefault
    }
  }
})
